import {Component, inject} from "@angular/core";
import {AdministrationTableService} from "../administration-table.service";
import {IId} from "@models";

@Component({
	selector: "sim-administration-table-paginator",
	templateUrl: "./administration-table-paginator.component.html",
	styleUrl: "./administration-table-paginator.component.scss",
	standalone: false,
})
export class AdministrationTablePaginatorComponent<T extends IId> {
	protected stateService = inject<AdministrationTableService<T>>(AdministrationTableService);
}
